import { type BaseGiftCardRepository } from "../../_Bases/BaseGiftCardRepository";
import { type LocalDatabaseGiftCard } from "../../_Bases/BaseGiftCardRepository";
import { type InternalIndexedDBDatabase } from "../../DataStores/Database";
import BaseIndexedDBRepository from "../../Implementations/BaseIndexedDBRepository";

export default class IndexedDBGiftCardRepository extends BaseIndexedDBRepository<
    LocalDatabaseGiftCard
> implements BaseGiftCardRepository {
    public readonly source: InternalIndexedDBDatabase["giftCards"];
    protected readonly dataTypeName = "Gift Card";

    constructor(source: InternalIndexedDBDatabase) {
        super();

        this.source = source.giftCards;
    }

    /**
     * Gets the gift card/s with the code provided
     * @param code
     * @returns {Promise<object>}
     */
    public code(code: string): Promise<Array<LocalDatabaseGiftCard>> {
        return this.source
            .where("code")
            .equalsIgnoreCase(code)
            .toArray();
    }
}
